/**
 * ETP Content Cards – Splide.js initialisation for slider layout.
 *
 * Only active when layout = "slider" is selected in the Bricks element.
 * Above 1280px Splide destroys itself (destroy: true breakpoint) and CSS takes
 * over with a CSS Grid layout.  Below 1280px Splide renders a touch/drag
 * carousel with a right-peek effect and pagination dots.
 */

export function initContentCardsSlider(scope) {
  const roots = (scope || document).querySelectorAll(
    '.etp-cards--slider:not([data-etp-ccs-ready])'
  );

  // mediaQuery: 'min' → breakpoints are min-width values. Aligned with SCSS
  // tokens: 900 = bp-s, 1280 = bp-m.
  // Default options apply to the smallest viewport (< 900px).
  // At 900px+: slightly more right padding for the peek effect.
  // At 1280px+: destroy Splide, CSS Grid takes over.
  const options = {
    type:        'slide',
    perPage:     1,
    perMove:     1,
    gap:         '20px',
    arrows:      false,
    pagination:  true,
    drag:        true,
    mediaQuery:  'min',
    breakpoints: {
      900:  { padding: { right: '35%' } },
      1280: { destroy: true },
    },
  };

  roots.forEach((root) => {
    if (!window.Splide) {
      console.warn('[ETP content-cards-slider] window.Splide missing.');
      return;
    }

    const splideRoot = root.querySelector('.splide');
    const hasTrack   = !!root.querySelector('.splide__track');
    const hasList    = !!root.querySelector('.splide__list');

    if (!splideRoot || !hasTrack || !hasList) {
      console.warn('[ETP content-cards-slider] skip init, incomplete markup.');
      return;
    }

    try {
      const splide = new window.Splide(splideRoot, options);
      splide.mount();

      // Wire up the custom prev/next buttons sitting below the slider.
      const prevBtn = root.querySelector('.etp-nav-arrow--prev');
      const nextBtn = root.querySelector('.etp-nav-arrow--next');

      if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
      if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));

      // Chrome treats <a> and <img> as natively draggable, which steals the
      // swipe gesture from Splide. draggable="false" is the HTML5-standard
      // opt-out and works cross-browser.
      root.querySelectorAll('.splide__slide a, .splide__slide img')
        .forEach((el) => el.setAttribute('draggable', 'false'));

      root.dataset.etpCcsReady = 'true';
    } catch (err) {
      console.warn('[ETP content-cards-slider] init failed.', err);
    }
  });
}
